import { storage, usersCollection } from '../../config/firebase';

let state = {
	musicVideos: [],
	loading: false,
	notification: { message: '', type: '' },
};
let getters = {
	musicVideos: state => state.musicVideos,
	musicVideoLoading: state => state.loading,
	musicVideoNotification: state => state.notification,
};
let actions = {
	async getMusicVideos({ commit }, payload) {
		
		commit('setMusicVideoLoading', true);
		usersCollection.doc(payload).onSnapshot(async snapshot => {
			let { music_videos } = snapshot.data();
			
			music_videos = music_videos ? music_videos : [];
			commit('setMusicVideosData', music_videos);
			commit('setMusicVideoLoading', false);
		});
	},
	async addMusicVideo({ commit }, payload) {
		
		commit('setMusicVideoLoading', true);
		let id = payload.id;
		delete payload.id;
		try {
			await usersCollection
				.doc(id)
				.get()
				.then(async snapshot => {
					let data = snapshot.data();
					let { music_videos } = data;
					music_videos = music_videos ? music_videos : [];
					for (let media of payload.media) {
						let i = usersCollection.doc().id;
						let { isURL } = media;
						if (!isURL) {
							let { file } = media;
							let parts = file.name.split('.');
							let fileExt = parts[parts.length - 1];
							let fileName = i + '.' + fileExt;
							let fileRef = storage
								.ref('music_videos')
								.child(id)
								.child(fileName);
							await fileRef.put(file);
							media['url'] = await fileRef.getDownloadURL();
						}
						let obj = {
							title: media.title,
							url: media.url,
						};
						music_videos.push({ ...obj });
					}
					data['music_videos'] = music_videos;
					await usersCollection.doc(id).update({ ...data });
				});
		} catch (err) {
			
			commit('setMusicVideosNotification', {
				message: err.message,
				type: 'error',
			});
		} finally {
			commit('setMusicVideoLoading', false);
		}
	},
	async editMusicVideo({ commit }, payload) {
		commit('setMusicVideoLoading', true);
		let id = payload.id;
		delete payload.id;
		try {
			usersCollection
				.doc(id)
				.get()
				.then(async snapshot => {
					let { idx } = payload;
					delete payload.idx;
					let data = snapshot.data();
					let { music_videos } = data;
					music_videos[idx] = { ...payload };
					data['music_videos'] = music_videos;
					await usersCollection.doc(id).update({ ...data });
				});
			commit('setMusicVideosNotification', {
				message: 'Streaming Links Updated',
				type: 'success',
			});
		} catch (err) {
			
			commit('setMusicVideosNotification', {
				message: err.message,
				type: 'error',
			});
		} finally {
			commit('setMusicVideoLoading', false);
		}
	},
	async deleteMusicVideo({ commit }, payload) {
		commit('setMusicVideoLoading', true);
		let id = payload.id;
		delete payload.id;
		try {
			usersCollection
				.doc(id)
				.get()
				.then(async snapshot => {
					let idx = payload.idx;
					delete payload.idx;
					let url = payload.url;
					delete payload.url;
					let data = snapshot.data();
					let { music_videos } = data;
					music_videos = music_videos.filter(
						(music_video, index) => idx != index
					);
					data['music_videos'] = music_videos;
					await usersCollection.doc(id).update({ ...data });
					try {
						await storage.refFromURL(url).delete();
					} catch (err) {}
				});
			commit('setMusicVideosNotification', {
				message: 'Streaming Links Deleted',
				type: 'success',
			});
		} catch (err) {
			
			commit('setMusicVideosNotification', {
				message: err.message,
				type: 'error',
			});
		} finally {
			commit('setMusicVideoLoading', false);
		}
	},
};
let mutations = {
	setMusicVideosData(state, payload) {
		state.musicVideos = payload;
	},
	setMusicVideoLoading(state, payload) {
		state.loading = payload;
	},
	setMusicVideosNotification(state, payload) {
		let { notification } = state;
		notification.message = payload.message;
		notification.type = payload.type;
		state.notification = notification;
		window.setTimeout(() => {
			let obj = { message: '', type: '' };
			state.notification = obj;
		}, 5000);
	},
};
export default { state, getters, actions, mutations };
